import { z } from 'zod';

export const ProjectPhaseSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  name: z.string(),
  sort_order: z.number().int().default(0),
  created_by: z.string().uuid().nullable(),
});

export const CreateProjectPhaseSchema = z.object({
  project_id: z.string().uuid(),
  name: z.string().min(1, 'Phase name is required'),
  sort_order: z.number().int().default(0),
});

export const UpdateProjectPhaseSchema = CreateProjectPhaseSchema.partial();

export type ProjectPhase = z.infer<typeof ProjectPhaseSchema>;
export type CreateProjectPhase = z.infer<typeof CreateProjectPhaseSchema>;
export type UpdateProjectPhase = z.infer<typeof UpdateProjectPhaseSchema>;
